import React from "react";
import { View, StyleSheet } from "react-native";
import { useNavigation, type NavigationProp } from "@react-navigation/native";
import {
  QuestionLayout,
  SquareOptionButton,
} from "@src/packages/medical-history/components";
import { useTranslations } from "@src/packages/i18n";
import { useFamilyHistory } from "../FamilyHistoryContext";
import type { FamilyHistoryStackParamList } from "../FamilyHistoryNavigator";
import { YES_NO_OPTIONS } from "../options";

export function DnaTestScreen() {
  const t = useTranslations();
  const { state, updateState } = useFamilyHistory();
  const navigation =
    useNavigation<NavigationProp<FamilyHistoryStackParamList>>();

  const current =
    state.hasDoneDNAAncestryReport === true
      ? "yes"
      : state.hasDoneDNAAncestryReport === false
        ? "no"
        : null;

  const handleSelect = (value: "yes" | "no") => {
    updateState({
      hasDoneDNAAncestryReport: value === "yes",
    });
  };

  const handleNext = () => {
    if (state.hasDoneDNAAncestryReport === true) {
      navigation.navigate("DnaTestReport");
    } else {
      navigation.navigate("Adopted");
    }
  };

  return (
    <QuestionLayout
      title={t("med_history.family_history.dna_test_title")}
      subtitle={t("med_history.family_history.dna_test_subtitle")}
      onBack={() => navigation.goBack()}
      onSave={handleNext}
      saveDisabled={current === null}
      saveLabel={t("med_history.shared.next")}
    >
      <View style={styles.row}>
        {YES_NO_OPTIONS.map((option) => (
          <SquareOptionButton
            key={option.id}
            icon={option.icon}
            label={t(option.labelKey)}
            isSelected={current === option.id}
            onPress={() => handleSelect(option.id)}
            iconSize={24}
            containerSize={48}
            labelSize="lg"
          />
        ))}
      </View>
    </QuestionLayout>
  );
}

const styles = StyleSheet.create({
  row: {
    flexDirection: "row",
    gap: 12,
    width: "100%",
    marginBottom: 40,
  },
});
